module.exports = __webpack_public_path__ + "media/tol/bghead-old-2d380f6e.png";